import {
  isNullOrUndefined,
  UTC,
  TimeSpan,
  TimestampRange,
}                                 from 'rewire-common';
import {
  IRowData,
  IGridOptions,
}                                 from 'rewire-grid';
import {
  ITimecard,
  ITimecardTemplate,
}                                 from '../DataTypes';
import { localTimeZoneUTCNow }    from '../utility/DateUtils';
import TimecardGridModel          from './TimecardGridModel';

class TimecardTemplateGridModel extends TimecardGridModel {
  constructor() {
    super();
  }

  loadTemplates(timecardTemplates?: any[], options?: IGridOptions, locked?: boolean, viewOnly?: () => boolean) {
    const earnedDate = localTimeZoneUTCNow().startOfDay();
    const timecards  = timecardTemplates && this.convertToTimecards(timecardTemplates, earnedDate);
    super.load(timecards, options, locked, earnedDate, viewOnly);
  }

  convertToTimecards(timecardTemplates: ITimecardTemplate[], earnedDate: UTC): ITimecard[] {
    const timecards = timecardTemplates?.map((timecardTemplate: ITimecardTemplate) => {
      return this.convertToTimecard(timecardTemplate, earnedDate);
    });
    return timecards;
  }

  convertToTimecard(timecardTemplate: ITimecardTemplate, earnedDate: UTC): ITimecard {
    const start    = !isNullOrUndefined(timecardTemplate.start) ? earnedDate.add(timecardTemplate.start!, TimeSpan.hours, 4) : undefined;
    const end      = !isNullOrUndefined(timecardTemplate.end)   ? earnedDate.add(timecardTemplate.end!, TimeSpan.hours, 4)   : undefined;
    const timecard = {
      ...timecardTemplate,
      effective: start && end && new TimestampRange(start, end),
      earnedDate: earnedDate,
    } as ITimecard;

    return timecard;
  }

  set(data: (IRowData | undefined)[], commit: boolean = true) {
    const rowDatas = data.slice();
    rowDatas.forEach((rowData: IRowData) => {
      rowData.data = this.convertToTimecard(rowData.data as ITimecardTemplate, this.earnedDate!);
    });
    rowDatas.push(this.defaultRowData);
    this.grid.set(rowDatas);
    commit && this.grid.commit();
  }

  get(): IRowData[] {
    // excludes the blank data entry row
    const rowDatas = this.gridDataRows;

    return rowDatas.map((rowData: IRowData) => {
      const earnedDate              = rowData.data!.earnedDate;
      const effective               = rowData.data!.effective;
      const start                   = effective?.start;
      const end                     = effective?.end;
      const timecardTemplateRowData = {...rowData};
       timecardTemplateRowData.data = {
        ...timecardTemplateRowData.data,
        start: start?.subtract(earnedDate, TimeSpan.hours, 4),
        end: end?.subtract(earnedDate, TimeSpan.hours, 4),
      };
      delete timecardTemplateRowData.data.effective;
      delete timecardTemplateRowData.data.earnedDate;
      return timecardTemplateRowData as IRowData;
    });
  }
}

export default TimecardTemplateGridModel;
